/**
 * Common - Header organism
 */
import * as Utils from '../Utils';

// Constants (ids)
const siteId = 'site';
const headerId = 'header';
const navId = 'mainNav';

// Constants (classes)
const overlayClass = 'o-header--overlay';
const stickyClass = 'o-header--sticky';

/**
 * Reference to the header element.
 * @type {Object}
 */
let header = {};

/**
 * Initial height for the header.
 * @type {Number}
 */
let initialHeight = 0;

function getHeader() {
  return header;
}

function getInitialHeight() {
  return initialHeight;
}

function setInitialHeight(anHeight) {
  initialHeight = anHeight;
}

function addOverlay() {
  if (header.hasClass(overlayClass)) {
    return;
  }

  header.addClass(overlayClass);
}

function initNoHead() {
  if (header.length && Utils.getUrlParameter('nohead') === 'true') {
    header.remove();
    const footerN = $('#footerNewsletter');
    if (footerN.length) {
      footerN.remove();
    }
  }
}

function init() {
  // Save reference to the header element
  header = $(`#${headerId}`);

  initNoHead();
}

// Named exports - Constants
export {
  siteId,
  headerId,
  navId,
  overlayClass,
  stickyClass,
};

// Named exports - Functions
export {
  init,
  getHeader,
  getInitialHeight,
  setInitialHeight,
  addOverlay,
};



// WEBPACK FOOTER //
// ./js/common/organism/header.js